import create from 'zustand';
import produce from 'immer';

// internal
import * as ProjectStore from '@app/typings/stores/initializing/project';
import * as ProjectService from '@service/project';
import * as storage from '@app/utils/localStorage';
import { handleError } from '@app/utils/service';

const state: ProjectStore.ProjectState = {
  selected: { id: '', name: '' },
};

export const useProjectStore = create<ProjectStore.ProjectStore>((set, get) => ({
  ...state,
  init: async () => {
    // before check token call function
    if (storage.getToken()) {
      const projectId = storage.getProject();
      set(
        produce<ProjectStore.ProjectState>((state) => {
          state.selected = {
            id: projectId,
          };
        }),
      );

      const data = await get().getByIdService(projectId);
      set(
        produce<ProjectStore.ProjectState>((state) => {
          state.selected = {
            id: projectId,
            name: data.name,
          };
        }),
      );
    }
  },
  getByIdService: async (id) => {
    try {
      const { data } = await ProjectService.fetchProjectWithId(id);
      if (data.success) {
        return data.data;
      }
    } catch (error) {
      handleError(error);
    }

    return undefined as any;
  },
  onSelected: (id, name = '') => {
    set(
      produce<ProjectStore.ProjectState>((state) => {
        state.selected = {
          id,
          name,
        };
      }),
    );

    storage.setProject(id);
  },

  onSetTab(tab) {
    set(
      produce<ProjectStore.ProjectState>((state) => {
        state.holdingTab = tab;
      }),
    );
  },
}));
